import {DateType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {Atividade} from "./atividade";

@JacksonType("AliquotaProgressivaAtividadeExclui")
@JsonIdentityInfo()
export class AliquotaProgressivaAtividadeExclui extends SonnerBaseEntity {

  id: number;

  @JacksonType("Atividade")
  atividade: Atividade;

  @DateType()
  fim: Date;

  @DateType()
  inicio: Date;
}
